<template>
    <input
      type="text"
      :value="value"
      placeholder="Enter uint256"
      @input="validateInput"
    />
  </template>
  
  <script>
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    methods: {
      validateInput(event) {
        const input = event.target.value;
        if (input.match(/^(0|[1-9]\d*)(\.\d+)?$/)) {
          // input is a valid uint256, emit the input event
          this.$emit('input', input);
        }
        else {
          // input is not valid, don't emit the input event
          event.target.value = this.value;
        }
      }
    }
  }
  </script>